import AppConst from 'consts/AppConst';
import ScreenConst from 'consts/ScreenConst';
import * as RNLocalize from 'react-native-localize';

let countryCode = RNLocalize.getCountry();
let languageCode = '';
let locales = RNLocalize.getLocales();
let detectedLanguage = '';
let isVietNam = countryCode?.toLowerCase() === 'vn';
let isLaos = countryCode?.toLowerCase() === 'la';
if (locales && locales.length > 0) {
  for (let i = 0; i < locales.length; i += 1) {
    const local = locales[i];
    if (!languageCode) languageCode = local.languageCode;
    if (!detectedLanguage && local.languageCode === 'lo') detectedLanguage = 'lo';
    if (!detectedLanguage && local.languageCode === 'vi') detectedLanguage = 'vi';
    if (local.countryCode?.toLowerCase() === 'vn') {
      isVietNam = true;
    }
    if (local.countryCode?.toLowerCase() === 'la') {
      isLaos = true;
    }
  }
}
let language = detectedLanguage || (isLaos ? 'lo' : isVietNam ? 'vi' : 'en');
const timezone = RNLocalize.getTimeZone();
if (__DEV__) {
  console.log('->countryCode', countryCode);
  console.log('->locales', locales);
  console.log('->language', language);
  console.log('-> timezone', timezone);
}

let mode = 'local';
// mode = 'dev';
// mode = 'beta';
mode = 'prod';

// Prod build
let debugScreen = 'TestScreen';
debugScreen = null;
if (!__DEV__) {
  mode = 'prod';
  debugScreen = null;
}
// if (!__DEV__ && AppConst.IS_DEV_BUILD) mode = 'beta';

let darkMode = true;
let currency = '₫';
let timeFormat = 'DD/MM/YYYY';
darkMode = false;
let prefix = {
  unit: 'DV',
  debt: 'DE',
  order: 'HD',
  reciept: 'PT',
  product: 'SP',
  category: 'DM',
  customer: 'KH',
  provider: 'NCC',
  composition: 'TP',
  importOrder: 'NH',
  importReturn: 'TH',
  returntOrder: 'RT',
  customerGroup: 'CG',
  paymentVoucher: 'PC'
};
let settings = {
  showVietQR: false,
  autoUpdate: true,
  fontSizeType: 2,
  showOdd: true,
  showOrderStatus: false,
  showGrid: false,
  showDebt: true,
  showDiscount: true,
  discountType: 0,
  surchargeType: 0,
  surchargePayType: 0,
  showWarningOutStock: false,
  showRevenue: true,
  showLogo: true,
  showHomeRevenue: true,
  showHomeChart: true,
  showHomeFinancial: true,
  showHomeStatistial: true,
  showOrderCustomer: false,
  timeFormat: 'DD/MM/YYYY',
  showProtection: false,
  pin: '',
  hiddenMenuId: [42]
};

const staffSettings = {
  showInstock: true,
  customerShowMode: 0 // 0: public, 1: owner, 2: private (bỏ, dùng staff permission)
};

let features = {
  purchase: true,
  whatsapp: '',
  voucherForPosDevice: true,
  posDevice: true,
  shopDomain: true
};

const Configs = {
  init: () => {
    if (['NG', 'TG', 'BJ', 'BF', 'CV', 'CI', 'GH', 'GN', 'GW', 'LR', 'NE', 'SN'].indexOf(Configs.countryCode?.toUpperCase()) >= 0) {
      Configs.isAfricaCountry = !Configs.isPrepareVersion;
      Configs.language = 'en';
      Configs.features = { ...Configs.features, purchase: false, whatsapp: '+2349137900354' };
    }
  },
  hasEvent: false,
  isAfricaCountry: false,
  hostType: null, // 0 = VN1, 1 = SG, 2 = VN2, null = auto
  features,
  countryCode,
  languageCode,
  startScreen: ScreenConst.AUTH_NAVIGATOR,
  debugScreen,
  mode,
  user: {},
  online: false,
  draftMode: false,
  token: '',
  isFreeVersion: true || !__DEV__,
  adsEnable: false,
  prefix,
  language: language,
  darkMode,
  currency,
  printCount: 0,
  timeFormat,
  dateTimeFormat: `HH:mm ${timeFormat}`,
  fullAdsMaxEventCount: 20,
  settings,
  pointSettings: { active: false, mtpRate: 100, ptmRate: 10, allowPayment: true, allowForSaleProduct: false, allowForOrderPayByPoint: false, showPoinOnBill: true },
  staffSettings,
  billPrinter: {},
  labelPrinter: {},
  printer: {
    name: '',
    address: '',
    displayName: '',
    type: 0,
    size: 80,
    method: 0,
    dpi: 203,
    threshold: 160,
    speed: 0,
    spacingBottom: 3,
    tearOffset: 23,
    iosNetworkMode: 'rawSocket' // legacy or rawSocket
  }, // Type 0 - blue, 1-net, 2: USB, 3: Sunnmi
  invoiceThank: '',
  invoiceSurchage: '',
  hasOfflineData: false,
  isManagerApp: true,
  staff: null,
  orderSettings: {
    vat: 0,
    showVAT: false,
    showNote: true,
    showSurcharge: true,
    showDiscount: true,
    showPaymentMethod: true,
    showPaid: true,
    showItemPrice: true,
    showSurchargePayType: true,
    paymentType: 0,
    lastStatus: 1,
    debtActive: true,
    hourlyService: false,
    hourlyServiceName: '',
    hourlyPrices: [],
    extraTopping: false,
    productSeparate: true,
    autoPromotion: true,
    useLastPrice: false, // Tự động dùng giá bán gần nhất của khách
    showPromotion: true,
    shipping: false,
    template: true,
    indexAsc: true, // Item thêm vào sẽ tăng index
    searchType: 1, // Tìm kiếm đơn hàng theo 1: tên kh, 0: theo myID, 2: Theo sđt
    daysCanEdit: 180 // days
  },
  productSettings: {
    averageBuyPrice: true,
    sortType: 0,
    initQuantity: 0,
    inventoryActive: true,
    showImage: true,
    showBarcode: true,
    showSku: true,
    showTypes: true,
    showComposition: true,
    showSellPrice1: true,
    showSellPrice2: true,
    showQuantity: true,
    showVat: true,
    showExpiredDate: true,
    showNote: true,
    showContent: true,
    showUnit: true,
    showCategory: true
  },
  billSettings: {
    showPoint: true,
    showOldDebt: true,
    showMustPayMoney: true,
    showTotalMoney: true,
    showMoneyText: true,
    showSlot: true,
    showTime: true,
    showProductImage: false,
    showLogo: true,
    showaSellerLogo: true,
    showThank: true,
    showId: true,
    showSignature: true,
    invoiceText: {},
    showPaid: true,
    showRemain: true,
    showQuantity: true,
    showProductMoney: true,
    showVietQR: true,
    showBankQR: true,
    showPromotion: true,
    showDiscount1: true, // Money
    showDiscount2: false, // Percent
    showSurchargeShopPay: true,
    billType: -1, // Loại bill mặc định
    qrType: -1,
    qrSize: 200,
    qrMoneyType: 0 // Hiển thị tổng nợ
  },
  printBarcodeSettings: {
    type: 0,
    driverType: 0,
    showShopName: true,
    showUnit: true,
    showProductName: true,
    showBarcode: true,
    showBarcodeText: true,
    showPrice: true,
    showCurrency: true,
    printSize: { width: 35, height: 22 },
    dpi: 203,
    column: 2,
    paddingH: 0,
    barcodeWidth: 1.5,
    gap: 3,
    address: '',
    name: '',
    autoPrint: false,
    productId: 0,
    vendorId: 0
  },
  warehouse: { id: 0 },
  isPrepareVersion: AppConst.IS_IOS,
  eInvoiceSettings: { active: false, auto: false, defaultInfoId: 0, showOnBill: true, forNotPayOrder: false, autoSign: true },
  localSettings: { fontSizeIncrease: 0 },
  appConfigs: {
    hotline: '0867945110',
    messenger: 'https://m.me/quanlybanhangaseller',
    youtube: 'https://www.youtube.com/@aSellerPOS',
    facebook: 'https://www.facebook.com/quanlybanhangaseller',
    tiktok: '',
    version: ''
  },
  timezone
};

Configs.init();

export default Configs;
